module.exports = __webpack_public_path__ + "media/src/images/mails/badge_grade_b-ed126473c85f9a1640889cd40e5f178c.png";